import React from "react";
import { Modal, Box } from "@mui/material";
import ProgressWithLogo from "../custom-components/ProgressWithLogo";

function LoadingModal({ open, message, progress }) {
  return (
    <Modal
      open={open}
      aria-labelledby="loading-modal-title"
      aria-describedby="loading-modal-description"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box>
        <ProgressWithLogo message={message} progress={progress} />
      </Box>
    </Modal>
  );
}

export default LoadingModal;
 